import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

interface GeneralTablesCellsTdLinkToSignature {
  Args: {
    cellData: {
      model: string;
      route: string;
      value: string;
    };
  };
}

const GeneralTablesCellsTdLinkTo = <template>
  <LinkTo
    @model={{@cellData.model}}
    @route={{@cellData.route}}
    class="prism-link prism-link--standalone prism-link--small"
  >
    {{@cellData.value}}
  </LinkTo>
</template> satisfies TOC<GeneralTablesCellsTdLinkToSignature>;

export default GeneralTablesCellsTdLinkTo;
